import React from 'react';
import {Link} from 'react-router-dom';
import './navbar.css';

function Navbar(){
    return <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
    <div className="container-fluid">
  
    <a className="navbar-brand" href="#">SINTUFF</a>

    {/* <a className="navbar-brand" href="/#">
      <img src="/Images/logo_pq.png" alt="" width="30" height="24" />
    </a> */}
  
    
  
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"></button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
    <ul className="navbar-nav">
      <li className="nav-item">
        <Link to="/app" className="nav-link" aria-current="page" href="#">Home</Link>
      </li>
      <li className="nav-item">
        <Link to="/app" className="nav-link" aria-current="page" href="#">Cadastro de Sindicalizados</Link>
      </li>
      <li className="nav-item">
        <Link to="/app/calendario" className="nav-link" aria-current="page" href="#">Agendamento</Link>
      </li>   





      <li className="nav-item">
        <Link to="/app" className="nav-link" aria-current="page" href="#">Sair</Link>
      </li>
    </ul>
    </div>
    </div>
  </nav>
  }

  export default Navbar;